

import React, { Component } from 'react';

import Breadcrumb from "../common/breadcrumb";
import intl from "react-intl-universal";

import { listContactUsImage } from "@/utils/user";

import "./login.css"
class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null
    };
  }

  componentDidMount() {
    listContactUsImage().then(res => {
      if (res && res.data.length > 0) {
        this.setState({ data: res.data[0].imageUrl })
      }
    })
  }
  render() {
    const { data } = this.state;

    return (
      <div>

        {/*about section*/}
        <section className="about-page  section-b-space">
          <div className="container">
            <img className='about-us' src={data} alt="" />
          </div>
        </section>

      </div>
    )
  }
}

export default Contact